export default {
  TOGGLE_BUG_REPORT_DIALOG: (state, payload) => {
    state.bugReportDialog = payload;
  }
};


// WEBPACK FOOTER //
// ./src/store/bugReport/mutations.js